import React from 'react'  
import axios from 'axios'
import LoadingPage from './LoadingPage'
import { Link } from "react-router-dom";
import { Divider } from 'primereact/divider';

class VyberZastupitelstva extends React.Component {  
    constructor(props) {
        super(props);

        this.state = {
            basicData : undefined
        }

        this.componentDidMount = this.componentDidMount.bind(this);
    }

    async componentDidMount() {
        await axios.get( this.props.apiBaseUrl + 'councils').then((response) => {
            this.setState({basicData: response.data});
        });
    }

    render() {
        const { basicData } = this.state;

        if (basicData !== undefined) {
            return (
                <div className='sm:pt-3 md:pt-5 lg:pt-8 flex flex-column'>
                    <span className="p-3 mb-3 flex flex-column align-items-center">
                        <img src={ this.props.baseUrl + `loga/Logo_Brno_RED_CMYK.png` } alt="logo_MMB" style={{ width:'400px'}} />
                        <h1 id="h1"><span>Vizualizace hlasování Zastupitelstva města Brna</span></h1>
                        <div className='grid mt-6'>
                            {basicData.map((council) => (
                                <div key={ council.poradi } className="col-12 md:col-6 px-5 mt-4 mb-4">
                                    <div className='p-3 shadow-2 mb-3 flex flex-column justify-content-center border-round' style={{ width: '90%', margin: 'auto', minHeight: '160px', minWidth: '250px' }}>
                                        <h2 className='ml-2 mt-0 text-center'>
                                            <Link 
                                                style={{ color: '#6366F1' }}
                                                to={`${ council.poradi }/`}
                                                key={council.poradi}>
                                                    { council.poradi }. zastupitelstvo
                                            </Link>
                                        </h2> 
                                        <div style={{ color: '#6366F1' }} className="flex align-items-center justify-content-center">({council.funkcni_obdobi_od}–{council.funkcni_obdobi_do})</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </span>
                    <footer id='main-footer' className='mt-5 relative md:absolute'>
                        <div className='flex justify-content-between flex-wrap card-container purple-container ml-5 mr-5'>
                            <Divider style={{ margin: 0 }}/>
                            <p className='text-500 line-height-3'>&copy; 2024</p>
                        </div>
                    </footer>
                </div>
            );
        } else {
            return (
                <LoadingPage />
            );   
        }  
    }
}

export default VyberZastupitelstva;
